import { runToposort } from "../utils/run-toposort";
const termPropertiesRelatedToValue = [
    "value",
    "ready",
    "hasValue",
    "isValid",
    "isComplete",
];
export function sortExpressions(expressionList, reference) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const edges = [];
    const unusedExpressions = new Set(expressionList);
    const addEdge = (from, to) => {
        if (!from) {
            return;
        }
        unusedExpressions.delete(from);
        unusedExpressions.delete(to);
        edges.push([from, to]);
    };
    for (const exp of expressionList) {
        for (const dep of exp.dependencies) {
            if (dep.type === "term" || dep.type === "iterable-term") {
                if (dep.property === "label") {
                    addEdge((_a = getRefTerm(reference, dep)) === null || _a === void 0 ? void 0 : _a.label, exp);
                    continue;
                }
                if (dep.property === "isRelevant") {
                    addEdge((_b = getRefTerm(reference, dep)) === null || _b === void 0 ? void 0 : _b.relevant, exp);
                    continue;
                }
                if (dep.property === "isRequired" || dep.property === "isComplete") {
                    addEdge((_c = getRefTerm(reference, dep)) === null || _c === void 0 ? void 0 : _c.required, exp);
                }
                if (dep.property === "isReadonly") {
                    addEdge((_d = getRefTerm(reference, dep)) === null || _d === void 0 ? void 0 : _d.readonly, exp);
                    continue;
                }
                if (termPropertiesRelatedToValue.includes(dep.property)) {
                    addEdge((_e = getRefTerm(reference, dep)) === null || _e === void 0 ? void 0 : _e.calculate, exp);
                    if (dep.property === "isValid" || dep.property === "isComplete") {
                        addEdge((_f = getRefTerm(reference, dep)) === null || _f === void 0 ? void 0 : _f.validation, exp);
                    }
                    continue;
                }
            }
            if (dep.type === "iterable") {
                if (dep.property === "count") {
                    addEdge((_g = reference.iterables[dep.iterableName]) === null || _g === void 0 ? void 0 : _g.count, exp);
                    continue;
                }
            }
        }
        // The value of required will depend on if the term is relevant
        if (exp.type === "basic" && exp.name === "required") {
            addEdge((_h = getRefTermByExp(reference, exp)) === null || _h === void 0 ? void 0 : _h.relevant, exp);
        }
        // Make sure validation expressions are sorted after enums relevant expressions
        if (exp.type === "validation") {
            addEdge((_j = getRefTermByExp(reference, exp)) === null || _j === void 0 ? void 0 : _j.enumsRelevant, exp);
        }
        // Make sure that expressions inside iterables are sorted after the iterable count
        if (exp.iterableName && exp.type !== "count") {
            addEdge((_k = reference.iterables[exp.iterableName]) === null || _k === void 0 ? void 0 : _k.count, exp);
        }
    }
    // array combining unusedExpressions and sorted expressions by dependency
    return Array.from(unusedExpressions).concat(runToposort(edges));
}
function getRefTerm(reference, dep) {
    var _a;
    if (dep.type === "iterable-term") {
        return (_a = reference.iterables[dep.iterableName]) === null || _a === void 0 ? void 0 : _a.terms[dep.termName];
    }
    return reference.terms[dep.termName];
}
function getRefTermByExp(reference, exp) {
    if (exp.iterableName) {
        return reference.iterables[exp.iterableName].terms[exp.termName];
    }
    return reference.terms[exp.termName];
}
//# sourceMappingURL=sort-expressions.js.map